// ── RiskRatingForm ──
import { Btn, FInput, FSelect, Field, Modal, ReadOnlyForm } from "../../../shared/ui";
import { useFreshForm } from "../../../shared/hooks";
import { NotesPanel } from "../components/NotesPanel";
import { useApp } from "../../../shared/appContext";

export const RiskRatingForm = ({ initial, loanid, readOnly }) => {
    const { role, modal, setModal, closeModal, saving, error, saveRec } = useApp();
    const [f, set] = useFreshForm(initial||{ loanid, ratingdate:"", rating:"" }, "RiskRatings");
    const ratingOptions = ["","1","2","3","4","5","6","7","8","9","10"];
    return <Modal title={readOnly?"View Risk Rating":initial?"Edit Risk Rating":"Add Risk Rating"} onClose={closeModal}
      onEdit={readOnly&&role.canEdit?()=>{ closeModal(); setModal({type:"riskrating-edit",rec:initial,loanid,onDone:modal.onDone}); }:null}>
      <ReadOnlyForm readOnly={readOnly}>
        <Field label="Rating Date"><FInput value={f.ratingdate?.slice(0,10)||""} onChange={set("ratingdate")} type="date" /></Field>
        <Field label="Rating"><FSelect value={f.rating||""} onChange={set("rating")} options={ratingOptions} /></Field>
      </ReadOnlyForm>
      {!readOnly&&error&&<div style={{ color:"#993C1D",fontSize:12,marginBottom:8,marginTop:8 }}>{error}</div>}
      <div style={{ display:"flex",gap:8,justifyContent:"flex-end",marginTop:16 }}>
        <Btn onClick={closeModal}>{readOnly?"Close":"Cancel"}</Btn>
        {!readOnly&&<Btn disabled={saving} onClick={()=>saveRec("saveRiskRating",{...f,loanid:f.loanid||loanid},initial?"Edited":"Added","RiskRatings",(initial?"Updated":"Added")+" risk rating",modal.onDone)} variant="primary">{saving?"Saving...":"Save"}</Btn>}
      </div>
      {initial?.id && <NotesPanel scope="record" entitytype="RiskRating" entityid={initial.id} accountid={initial.accountid} loanid={loanid} source="Risk Rating" />}
    </Modal>;
  };
